<div class="default-loading-page">
  <div id="preloader">
    <div id="loader"></div>
  </div>
</div>
